import BottomSheet from "@components/BottomSheet/BottomSheet"
import BottomSheetHeader from "@components/BottomSheetHeader/BottomSheetHeader"
import { QRBottomSheetBodyContainer } from "@components/QRBottomSheet/QRBottomSheet.styles"
import { BLACK } from "@styles/colors";
import { QRCodeSVG } from 'qrcode.react';
import JagadLogo from "@assets/images/JagadLogoBlackWithWhiteBackground.png"
import { useTranslation } from "react-i18next";

const QRBottomSheet = ({ 
    isOpen, 
    onClose,
    qrValue,
    height = '40%',
    bottomSheetHeaderTitle,
    qrLabel
}: { 
    isOpen: boolean, 
    onClose: () => void,
    qrValue: string,
    height?: string,
    bottomSheetHeaderTitle?: string,
    qrLabel?: string
}) => {
    const { t } = useTranslation();
    const defaultTitle = t('components.qrBottomSheet.defaultTitle');
    const defaultLabel = t('components.qrBottomSheet.defaultLabel');

    return (
        <BottomSheet 
            isOpen={isOpen} 
            onClose={onClose}
            title={t('components.qrBottomSheet.bottomSheetTitle')}
            height={height}
            header={<BottomSheetHeader title={bottomSheetHeaderTitle || defaultTitle} />}
        >
            <QRBottomSheetBody qrValue={qrValue} qrLabel={qrLabel || defaultLabel} />
        </BottomSheet>
    )
}

const QRBottomSheetBody = ({ qrValue, qrLabel }: { qrValue: string, qrLabel: string }) => {
    return (
        <QRBottomSheetBodyContainer>
            <QRCodeSVG value={qrValue} minVersion={6} size={168} imageSettings={{ src: JagadLogo, height: 50, width: 50, excavate: false }} />
            <span
                style={{
                    color: BLACK
                }}
            >{qrLabel}</span>
        </QRBottomSheetBodyContainer>
    )
}

export default QRBottomSheet